import { withAsyncLoading } from '../../lib/PST.Web.Common/src/hocs/withAsyncPageLoading/withAsyncPageLoading';

const LoadablePageCGU = withAsyncLoading(async () => import('./PageCGU').then((res) => res.PageCGU));

export { LoadablePageCGU };
